import styled from "styled-components";
import Modal from "react-modal";

export const Container = styled.form`
/* Example if using global or local CSS */
input::placeholder,
option,
textarea::placeholder{
 color: gray;
}
select {
  color: black !important;
}

.quantity-row {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

  .quantity {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }

  .quantity-amount {
    width: 100%;
  }

  .quantity-unit {
    width: 180px;
  }
  .option-quantity-unit {
    width: 100%;
    height: 40vh !important;
  }

  .popup-title {
    width: 100%;
    text-align: center;

    h1 {
      font-weight: 600;
    }
  }

  .ingredient-image-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 1rem;
    align-items: center;
    position: relative;

    .ingredient-image {
      width: 65px;
      height: 65px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
`;

const SelectContainer = styled.div` 
  width: 100%;
  font-family: sans-serif;
  background: var(--light-gray);
  height: 45px;
  color: black;
  font-size: 26px;
`;

const SelectedOption = styled.div`
  background: white;
  /* color: var(--text); */ 
  padding: 0.5rem;
  cursor: pointer; 
  height: 53px;
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 5px;
`;

const Dropdown = styled.select`
  width: 100%;
  max-height: 10rem;
  overflow-y: auto;
  background: white;
  font-size: 20px;
  color: black;
  border: 1px solid #ccc;
  padding: 0.5rem;
  border-radius: 5px;

  option:disabled {
    color: gray;
  }
`;

const Option = styled.option`
  padding: 0.5rem;
  cursor: pointer;
  color: black;

  &:hover {
    background: #e2e2e2;
  }
`;



const TextArea = styled.textarea`
  width: 100%;
  min-height: 10rem;
  padding: 1rem;
  font-size: 1.5rem;
  border: 1px solid var(--gray, #ccc);
  border-radius: 0.5rem;
  resize: vertical;
  box-sizing: border-box;
  color: black;
  /* &::placeholder {
    color: #777;
  } */

  &:focus {
    outline: none;
    border-color: var(--primary, #007bff);
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  }
`;
 const StyledReactModal = styled(Modal)`
      position: absolute;
      top: 50%;
      left: 50%;
      right: auto;
      bottom: auto;
      margin: auto;
      transform: translate(-50%, -50%);
      font-size: 2rem;
     
      border-radius: 2rem;
      background-color: white;
       @media (max-width: 500px) {
    width: 90%;
    padding: 1.5rem;
  }
  @media (max-width: 1200px) {
 
    margin-left: 2rem;

  }

`;


export { SelectContainer, SelectedOption, Dropdown, Option, TextArea ,StyledReactModal };
